"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _SignUp = _interopRequireDefault(require("./SignUp"));

var _SignIn = _interopRequireDefault(require("./SignIn"));

var _ForgotPassword = _interopRequireDefault(require("./ForgotPassword"));

var _ConfirmSignUp = _interopRequireDefault(require("./ConfirmSignUp"));

var _Snackbar = _interopRequireDefault(require("./Components/Snackbar"));

var _RequireNewPassword = _interopRequireDefault(require("./RequireNewPassword"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Complete = function Complete(_ref) {
  var onComplete = _ref.onComplete;
  (0, _react.useEffect)(function () {
    onComplete && onComplete();
  }, []);
  return null;
};

var Auth = function Auth(_ref2) {
  var onComplete = _ref2.onComplete,
      newAuthState = _ref2.newAuthState,
      history = _ref2.history,
      _ref2$location = _ref2.location;
  _ref2$location = _ref2$location === void 0 ? {} : _ref2$location;
  var _ref2$location$search = _ref2$location.search,
      search = _ref2$location$search === void 0 ? "" : _ref2$location$search,
      _ref2$initialAuthStat = _ref2.initialAuthState,
      initialAuthState = _ref2$initialAuthStat === void 0 ? "signin" : _ref2$initialAuthStat,
      _ref2$usernameField = _ref2.usernameField,
      usernameField = _ref2$usernameField === void 0 ? "email" : _ref2$usernameField,
      _ref2$initialUsername = _ref2.initialUsernameValue,
      initialUsernameValue = _ref2$initialUsername === void 0 ? "" : _ref2$initialUsername,
      _ref2$initialPassword = _ref2.initialPasswordValue,
      initialPasswordValue = _ref2$initialPassword === void 0 ? "" : _ref2$initialPassword,
      _ref2$signUpOrder = _ref2.signUpOrder,
      signUpOrder = _ref2$signUpOrder === void 0 ? ['username', 'name', 'password'] : _ref2$signUpOrder,
      _ref2$customFields = _ref2.customFields,
      customFields = _ref2$customFields === void 0 ? {
    "phone_number": {
      label: "Mobile Phone",
      required: false,
      type: 'phone',
      initialValue: "",
      validations: {
        "Valid phone number": /^\+\d\d?\d? \(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
      }
    },
    "name": {
      label: "Name",
      required: true,
      type: 'text',
      initialValue: "",
      validations: {
        "Can't be blank": /^.+$/
      }
    } // "given_name": {
    //   label: "First Name",
    //   required: true,
    //   type: 'text',
    //   initialValue: "",
    //   validations: {
    //     "Can't be blank": /^.+$/
    //   }
    // },
    // "address": {
    //   label: "Address",
    //   required: true,
    //   type: 'text',
    //   initialValue: "",
    //   validations: {
    //     "Can't be blank": /^.+$/
    //   }
    // },
    // "birthdate": {
    //   label: "Birthdate",
    //   required: true,
    //   type: 'text',
    //   initialValue: "",
    //   validations: {
    //     "Can't be blank": /^.+$/
    //   }
    // },
    // "custom:address2": {
    //   label: "Address 2",
    //   required: false,
    //   type: 'text',
    //   initialValue: "",
    //   validations: {}
    // },
    // "custom:city": {
    //   label: "City",
    //   required: true,
    //   type: 'text',
    //   initialValue: "",
    //   validations: {
    //     "Can't be blank": /^.+$/
    //   }
    // },
    // "custom:zip": {
    //   label: "Zip",
    //   required: true,
    //   type: 'text',
    //   initialValue: "",
    //   validations: {
    //     "Must be a valid zip code": /^\d{5}$|^\d{5}-\d{4}$/
    //   }
    // },
    // "custom:state": {
    //   label: "State",
    //   required: true,
    //   type: 'text',
    //   initialValue: "",
    //   validations: {},
    //   options: STATES.map(([label, value]) => ({label, value}))
    // },

  } : _ref2$customFields;
  var routeAuthState = !!location ? (location.pathname || "").replace(/\W/g, "") : "";

  var _useState = (0, _react.useState)(['signin', 'signup'].includes(routeAuthState) ? routeAuthState : initialAuthState),
      _useState2 = _slicedToArray(_useState, 2),
      authState = _useState2[0],
      setAuthState = _useState2[1]; //useState(queryString.parse(location.search).authState || initialAuthState);


  var _useState3 = (0, _react.useState)({}),
      _useState4 = _slicedToArray(_useState3, 2),
      message = _useState4[0],
      setMessage = _useState4[1];

  var _useState5 = (0, _react.useState)({}),
      _useState6 = _slicedToArray(_useState5, 2),
      authData = _useState6[0],
      setAuthData = _useState6[1];

  var _useState7 = (0, _react.useState)(_objectSpread({
    username: initialUsernameValue,
    password: initialPasswordValue
  }, Object.entries(customFields).reduce(function (acc, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];

    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, value.initialValue || ""));
  }, {}))),
      _useState8 = _slicedToArray(_useState7, 2),
      values = _useState8[0],
      setValues = _useState8[1];

  var getValues = function getValues() {
    return values;
  };

  (0, _react.useEffect)(function () {
    !!newAuthState && setAuthState(newAuthState);
  }, [newAuthState]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !!message && !!message.message && /*#__PURE__*/_react["default"].createElement(_Snackbar["default"], {
    message: message.message,
    type: message.type || 'info',
    forceOpen: !!message.message
  }), authState === "signup" ? /*#__PURE__*/_react["default"].createElement(_SignUp["default"], {
    onValueChange: function onValueChange(field, value) {
      return setValues(_objectSpread(_objectSpread({}, values), {}, _defineProperty({}, field, value)));
    },
    initialUsernameValue: values.username,
    initialPasswordValue: values.password,
    usernameField: usernameField,
    order: signUpOrder,
    customFields: customFields,
    onAuthStateChange: function onAuthStateChange(authState, message) {
      return [setAuthState(authState), setMessage(message)];
    },
    getValues: getValues
  }) : authState === "signin" ? /*#__PURE__*/_react["default"].createElement(_SignIn["default"], {
    onValueChange: function onValueChange(field, value) {
      return setValues(_objectSpread(_objectSpread({}, values), {}, _defineProperty({}, field, value)));
    },
    initialUsernameValue: values.username,
    initialPasswordValue: values.password,
    usernameField: usernameField,
    order: ['username', 'password'],
    onAuthStateChange: function onAuthStateChange(authState, message, authData) {
      return [setAuthState(authState), setMessage(message), setAuthData(authData)];
    }
  }) : authState === "forgotpassword" ? /*#__PURE__*/_react["default"].createElement(_ForgotPassword["default"], {
    onValueChange: function onValueChange(field, value) {
      return setValues(_objectSpread(_objectSpread({}, values), {}, _defineProperty({}, field, value)));
    },
    usernameField: usernameField,
    order: ['username', 'code', 'password'],
    onAuthStateChange: function onAuthStateChange(authState, message) {
      return [setAuthState(authState), setMessage(message)];
    }
  }) : authState === "confirmsignup" ? /*#__PURE__*/_react["default"].createElement(_ConfirmSignUp["default"], {
    initialUsernameValue: values.username,
    usernameField: usernameField,
    onValueChange: function onValueChange(field, value) {
      return setValues(_objectSpread(_objectSpread({}, values), {}, _defineProperty({}, field, value)));
    },
    onAuthStateChange: function onAuthStateChange(authState, message) {
      return [setAuthState(authState), setMessage(message)];
    }
  }) : authState === "requirenewpassword" ? /*#__PURE__*/_react["default"].createElement(_RequireNewPassword["default"], {
    initialUsernameValue: values.username,
    onValueChange: function onValueChange(field, value) {
      return setValues(_objectSpread(_objectSpread({}, values), {}, _defineProperty({}, field, value)));
    },
    onAuthStateChange: function onAuthStateChange(authState, message) {
      return [setAuthState(authState), setMessage(message)];
    },
    usernameField: usernameField,
    order: ['username', 'password'],
    customFields: customFields,
    authData: authData
  }) : /*#__PURE__*/_react["default"].createElement(Complete, {
    onComplete: onComplete
  }));
};

var _default = Auth;
exports["default"] = _default;